// MVP API 의 이용권 잔액 조회 (api/internal/httpapi/llm.go 의 GET /credits). 화면 표시용이다 — 차감은 서버가 대화마다 한다
import { z } from 'zod';

const TIMEOUT_MS = 15_000;

const Balance = z.object({ balance: z.number().int().nonnegative() });

/** 남은 이용권 장수, 읽지 못하면 null (0 으로 읽지 않는다 — 0 은 「없다」는 뜻이다) */
export async function fetchBalance(endpoint: string, token: string): Promise<number | null> {
  try {
    const res = await fetch(endpoint, { headers: { Authorization: `Bearer ${token}` }, signal: AbortSignal.timeout(TIMEOUT_MS) });
    if (!res.ok) return null;
    const body = Balance.safeParse(await res.json());
    return body.success ? body.data.balance : null;
  } catch {
    return null;
  }
}
